import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Search } from '@mui/icons-material';
import { TextField, IconButton } from '@totalsoft/rocket-ui';

const UserGroupListFiltersComponent = ({ filters, onChangeFilterValue }) => {
  const { t } = useTranslation();
  const onTextFilterChanged = name => event => {
    onChangeFilterValue(name, event);
  };

  const resetFilters = name => () => {
    const value = '';
    onChangeFilterValue(name, value);
  };

  return (
    <TextField
      value={filters.userGroupName || ''}
      onChange={onTextFilterChanged('userGroupName')}
      startAdornment={<Search />}
      endAdornment={
        <IconButton
          type='cancel'
          fontSize='medium'
          color='transparent'
          tooltip={t('Tooltips.ResetFilters')}
          onClick={resetFilters('userGroupName')}
        />
      }
    />
  );
};

UserGroupListFiltersComponent.propTypes = {
  filters: PropTypes.object.isRequired,
  onChangeFilterValue: PropTypes.func.isRequired
};

export default UserGroupListFiltersComponent;
